import { render } from "./default-vm-termination-grace-period-seconds.vue?vue&type=template&id=7839a9d8"
import script from "./default-vm-termination-grace-period-seconds.vue?vue&type=script&lang=js"
export * from "./default-vm-termination-grace-period-seconds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__